import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Space, Tabs } from 'antd';
import { DOCTOR_HOW_IT_WORKS_PAGES } from '@medicusunion/front-utils';
import { SIDEBAR_ICONS } from 'constants/layout';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_CONFIG_BY_TYPE } from 'gql/static';
import { GetConfigByType } from 'gql/static/__generated__/GetConfigByType';
import { CONFIG_PAGES } from 'constants/static';

import { StyledPage } from './styled';
import { Loading, PageWrapper } from 'components/ui';

const HowItWorks: FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();

  const { data, loading } = useQuery<GetConfigByType>(GET_CONFIG_BY_TYPE, {
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-and-network',
    variables: {
      query: {
        type: CONFIG_PAGES.DOCTOR_HOW_IT_WORKS,
        includeAll: '1'
      }
    }
  });

  const result =
    data?.getConfigByType.data.body?.[`${id}`]?.desktop?.[i18n.language]
      ?.content;

  const items = Object.values(DOCTOR_HOW_IT_WORKS_PAGES)
    .sort((a, b) => a.order - b.order)
    .map(item => ({
      key: item.key,
      label: (
        <Space>
          {SIDEBAR_ICONS[item.key]}
          {t(`how_it_works.${item.key}`)}
        </Space>
      )
    }));

  const onChangeTab = (key: string) => {
    navigate(`/how-it-works/${key}`);
  };

  return (
    <PageWrapper title={t('how_it_works.title')} color="white">
      <StyledPage>
        <Tabs activeKey={id} onChange={onChangeTab} items={items} />
        {loading ? (
          <Loading />
        ) : (
          <div
            className="how-it-works-content"
            dangerouslySetInnerHTML={{ __html: result }}
          />
        )}
      </StyledPage>
    </PageWrapper>
  );
};

export default HowItWorks;
